import { Box, Container, Typography } from "@mui/material";
import React from "react";
import {
  colorApp,
  colorBlack,
  textStyle,
  titleStyle,
} from "../../../Resources/Design/theme";

import idone from "./idone.jpg";
import idtwo from "./idtwo.jpg";

const imgstyle = {
  display: { xs: "none", sm: "none", md: "inline" },
  height: "auto",
  width: "auto",
  maxHeight: { xs: "0", sm: "0", md: "300px", lg: "280px" },
  borderRadius: "6px",
};

export default function Creators() {
  return (
    <Container
      maxWidth="lg"
      sx={{
        display: "flex",
        position: "relative",
        zIndex: 5,
        flexDirection: { xs: "column", sm: "row" },
        my: { xs: "60px", sm: "90px", md: "90px" },
      }}
    >
      <Box
        component={"img"}
        loading="eager"
        decoding="sync"
        src={idone}
        sx={{ ...imgstyle }}
      ></Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          maxWidth: { xs: "100%", sm: "100%", md: "380px" },
          textAlign: "left",
          mx: "auto",
          pl: "5px",
        }}
      >
        <Typography
          sx={{
            ...titleStyle,
            color: colorApp,
            width: "100%",
          }}
        >
          Zakladatelé
        </Typography>
        <Typography
          sx={{
            ...textStyle,
            color: colorBlack,
            mt: "14px",
            width: "100%",
          }}
        >
          Lars, Alík. Spolužáci od školky, punkeři od srdce… Co je ale hlavní,
          dva kamarádi, kteří zjistili, že chtějí od života víc. A tak se
          rozhodli spojit své největší záliby - Kynologii a videotvorbu. Chtěli
          jsme ta léta praxe přetavit v něco víc. A tak jednoho dne, kdy už se
          už cesty začaly smotávat do chaosu, přišel nápad. Jsme hrdí, že tento
          projekt můžeme vést. Odhodlaní ho posouvat výš. Kam? Tam kam
          dohlédneme a ještě dál.
        </Typography>
      </Box>
      <Box
        component={"img"}
        loading="eager"
        decoding="sync"
        src={idtwo}
        sx={{ ...imgstyle }}
      ></Box>
    </Container>
  );
}
